import { render, staticRenderFns } from "./Cargas.vue?vue&type=template&id=705b0fed&scoped=true"
import script from "./Cargas.vue?vue&type=script&lang=js"
export * from "./Cargas.vue?vue&type=script&lang=js"
import style0 from "./Cargas.vue?vue&type=style&index=0&id=705b0fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b0fed",
  null
  
)

export default component.exports